import { combineEpics } from 'redux-observable';
import { fg } from '@atlassian/jira-feature-gating';
import type { State, Action } from '../../state/types.tsx';
import { withKillSwitch } from '../../common/redux-observable/index.tsx';
import { loadWhiteboardsEntrypointExperimentHasAccessToConfluenceEpic } from './confluence-access/index.tsx';
import { loadWhiteboardsEntrypointExperimentHasConfluenceSpacesEpic } from './confluence-space/index.tsx';
import { loadHasViewedPulseEpic, setHasViewedPulseEpic } from './contextual-menu-pulse/index.tsx';
import { loadHasXflowFromWhiteboardsTouchpointEpic } from './has-xflow-from-whiteboards-touchpoint/index.tsx';

export const loadWhiteboardsEntrypointExperimentEpic = combineEpics<Action, State>(
	loadWhiteboardsEntrypointExperimentHasAccessToConfluenceEpic,
	loadWhiteboardsEntrypointExperimentHasConfluenceSpacesEpic,
	loadHasViewedPulseEpic,
	setHasViewedPulseEpic,
	...withKillSwitch(() => fg('grw_1037_expand_plan_in_whiteboards_gate'))([
		loadHasXflowFromWhiteboardsTouchpointEpic,
	]),
);
